import { ContainerOverlayLoader, FeatureSpinnerWrapper, GlobalOverlayLoader, OverlayLoader } from './SpinnerLoader.styles';
import React from 'react';
import './SpinnerLoader.scss';

type Props = {
    showOverlay?: boolean;
    showContainerOverlay?: boolean;
    clearDefaultText?: boolean;
    isFeatureSpinner?: boolean;
    isGlobalOverlay?: boolean;
    message: string | null;
};

const SpinnerLoaderComponent: React.FC<Props> = (props) => {
    return (
        <>
            {props.isGlobalOverlay && (
                <GlobalOverlayLoader>
                    <div className="loader-content">
                        <div className="lds-ripple">
                            <div />
                            <div />
                        </div>
                        {props.message && <div className="loader-text">{props.message}</div>}
                        {!props.message && <div className="loader-text">Loading</div>}
                    </div>
                    <div className="curtain" />
                </GlobalOverlayLoader>
            )}
            {props.showContainerOverlay && (
                <ContainerOverlayLoader>
                    <div className={`loader-wrapper`}>
                        {props.message && <div className="loader-text">{props.message}</div>}
                        {!props.message && <div className="loader-text">Loading</div>}
                    </div>
                </ContainerOverlayLoader>
            )}
            {props.showOverlay && (
                <OverlayLoader>
                    <div className="loader-wrapper">
                        <div className="loader-text-wrapper">
                            {props.message && <div className="loader-text">{props.message}</div>}
                            {!props.message && <div className="loader-text">Loading</div>}
                            <div className="lds-ripple">
                                <div />
                                <div />
                            </div>
                        </div>
                    </div>
                    <div className="curtain" />
                </OverlayLoader>
            )}
            {props.isFeatureSpinner && (
                <FeatureSpinnerWrapper>
                    <div className="inner-wrapper">
                        <div className="lds-ripple">
                            <div />
                            <div />
                        </div>
                        {!props.clearDefaultText && <div className="loader-text">Loading {props.message}</div>}
                        {props.clearDefaultText && <div className="loader-text">{props.message}</div>}
                    </div>
                </FeatureSpinnerWrapper>
            )}
            {!props.showOverlay && !props.showContainerOverlay && !props.isFeatureSpinner && !props.isGlobalOverlay && (
                <div>
                    <div className="lds-ripple">
                        <div />
                        <div />
                    </div>
                    {!props.clearDefaultText && <div className="loader-text">Loading {props.message}</div>}
                    {props.clearDefaultText && <div className="loader-text">{props.message}</div>}
                </div>
            )}
        </>
    );
};

export default SpinnerLoaderComponent;
